import { Plane, HardHat, Mountain, Truck, Factory, Ship, Fuel, Globe2 } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const CASES = [
  { icon: Plane, name: "Airlines", text: "Jet A-1 sourcing and aviation fuel coordination." },
  { icon: HardHat, name: "Construction Companies", text: "Diesel and fuel supply for sites and equipment." },
  { icon: Mountain, name: "Mining Operations", text: "High-volume fuel procurement for remote operations." },
  { icon: Truck, name: "Logistics & Fleet Operators", text: "Recurring diesel supply across routes and depots." },
  { icon: Factory, name: "Industrial Facilities", text: "Energy products for continuous plant operations." },
  { icon: Ship, name: "Marine Operators", text: "Marine fuel procurement and coordination." },
  { icon: Fuel, name: "Oil & Gas Companies", text: "Product sourcing and procurement support." },
  { icon: Globe2, name: "International Companies in Nigeria", text: "Local procurement capability without building it in-house." },
];

export default function UseCases() {
  return (
    <section id="use-cases" data-testid="use-cases-section" className="relative py-24 md:py-32 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag number="10" label="Who We Serve" />
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white max-w-xl">
              Built for operations that <span className="text-gold">can&rsquo;t stop.</span>
            </h2>
            <p className="text-white/55 max-w-md text-base leading-relaxed">
              One request. One procurement partner. Ongoing support — whether it&rsquo;s a
              single shipment, recurring supply or procurement across multiple locations.
            </p>
          </div>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CASES.map((c, i) => (
            <Reveal key={c.name} delay={0.05 * i}>
              <div
                data-testid={`use-case-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full border border-white/8 rounded-2xl p-7 hover:border-gold/40 hover:bg-white/[0.03] transition-all duration-500"
              >
                <c.icon className="w-6 h-6 text-gold/80 group-hover:text-gold transition-colors duration-300" strokeWidth={1.5} />
                <h3 className="font-outfit text-lg font-light text-white mt-5">{c.name}</h3>
                <p className="text-sm text-white/50 mt-2 leading-relaxed">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
